module.exports = "img/social/email-1.4053cdb.png";